export const MODAL_DATA_ATTRIBUTE = 'data-modal_slug'

export const isInlineModal = (target: HTMLElement) => target?.hasAttribute(MODAL_DATA_ATTRIBUTE)
